export const DURATION_COPY = {
  presetLabel: "Link lifetime",
  custom: "Custom",
  never: "Never",
  amountLabel: "Amount",
  unitLabel: "Unit",
  until: (date: string) => `Link works until ${date}`,
  noExpiry: "Link never expires",
} as const;
